import {
  BULLETIN_VIEW_MODAL_OPEN,
  BULLETIN_VIEW_MODAL_CLOSE
} from "redux/action/actionTypes";

const initialState = {
  open: false,
  bulletinUuid: undefined
};

export default function bulletinViewModalReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case BULLETIN_VIEW_MODAL_OPEN:
      return {
        ...state,
        open: action.open,
        bulletinUuid: action.bulletinUuid
      };

    case BULLETIN_VIEW_MODAL_CLOSE:
      return {
        ...state,
        open: action.open,
        bulletinUuid: action.bulletinUuid
      };

    default:
      return state;
  }
}
